export default __webpack_public_path__ + "static/media/publication-step-2.b630c4ee.svg";